module.exports = __webpack_public_path__ + "media/images/svgs/jobs/house-white-4e3f7ab07366d3f437fb9320757d17d2.svg";